import * as React from "react";
import MoreMenu from "../more-menu/more-menu";
import AppIcon from "common/app-icon";
import { withDefault } from "collection-utils";
import { Badge } from "../../../ui/views/badge/badge";
import { AppTileStyle } from "./app-tile-style";
import classNames from "classnames";
import { VisualStyle } from "designer/lib/dropdown-types";

interface MenuItem {
    content: string;
    onClick: () => void;
    style?: VisualStyle;
}

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    readonly name?: string;

    center?: boolean;

    readonly accentColor: string;
    readonly dimBackground: boolean;

    readonly caption?: string;
    readonly isEnabled?: boolean;
    readonly isSelected?: boolean;
    readonly menu?: MenuItem[];
    readonly badge?: string;
    readonly badgeColor?: string;
    readonly canHover?: boolean;

    readonly onClick: () => void;
    readonly onOpenExternally?: () => void;

    readonly isFavorite?: boolean;
    readonly setIsFavorite?: (isFavorite: boolean) => void;
}
interface State {
    readonly menuOpen: boolean;
}

const Star = ({ on, onClick }: { on: boolean; onClick(): void }) => {
    return (
        <svg
            className={`star star-${on ? "on" : "off"}`}
            onClick={e => {
                e.stopPropagation();
                onClick();
            }}
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.02059 1L8.93516 5.15079L13.4744 5.68899L10.1184 8.79252L11.0093 13.2759L7.02059 11.0432L3.0319 13.2759L3.92275 8.79252L0.566748 5.68899L5.10602 5.15079L7.02059 1Z"
                fill={on ? "#FFB900" : undefined}
                stroke="#FFB900"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default class AppTile extends React.PureComponent<Props, State> {
    public state: State = {
        menuOpen: false,
    };

    public render(): React.ReactNode {
        const {
            name,
            caption,
            isEnabled,
            menu,
            accentColor,
            isSelected,
            badge,
            badgeColor,
            dimBackground,
            onClick,
            canHover,
            onOpenExternally,
            isFavorite = false,
            setIsFavorite,
        } = this.props;

        // FIXME: We should't forward _all_ props to that div. We're even overwiting a few like `canHover`.
        const { onOpenExternally: _, ...rest } = this.props;
        let { className } = this.props;
        if (isEnabled === false) {
            className = "disabled " + withDefault(className, "");
        }

        if (dimBackground) {
            className = withDefault(className, "dim");
        }

        return (
            <AppTileStyle
                className={className}
                {...rest}
                onClick={onClick}
                background={accentColor}
                canHover={canHover ?? true}
                menuOpen={this.state.menuOpen}
                isSelected={isSelected === true}>
                {menu && (
                    <div className="hats-menu">
                        {onOpenExternally !== undefined && (
                            <AppIcon
                                icon="openExternal"
                                size={20}
                                onClick={e => {
                                    e.stopPropagation();
                                    onOpenExternally();
                                }}
                            />
                        )}
                        <MoreMenu
                            size={24}
                            items={menu}
                            descriptionForItem={i => ({
                                name: i.content,
                                visualStyle: i.style ?? "normal",
                            })}
                            onItemClick={i => i.onClick()}
                            onOpenChanged={n => this.setState({ menuOpen: n })}
                        />
                    </div>
                )}
                <div className="app-tile-upper-left">
                    {badge !== undefined && (
                        <Badge
                            position={false}
                            className={classNames("badge-" + badge.toLowerCase(), "hats-badge")}
                            bgColor={badgeColor}>
                            {badge}
                        </Badge>
                    )}
                    {setIsFavorite !== undefined && <Star on={isFavorite} onClick={() => setIsFavorite(!isFavorite)} />}
                </div>
                <div className="atile-content">
                    <div className="atile-app-icon">{this.props.children}</div>
                    {name !== undefined && (
                        <div className="atile-bottom-bar">
                            <div className="atile-name atile-left-column">
                                <div className="atile-overflow-wrapper">{this.props.name}</div>
                            </div>
                            {caption !== undefined && (
                                <div className="atile-caption atile-left-column">
                                    <div className="atile-overflow-wrapper">{caption}</div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </AppTileStyle>
        );
    }
}
